module.exports = __webpack_public_path__ + "static/img/processApp.a5bab879.png";